import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from "@material-ui/core";
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';

/**
 * expected props:
 * 
 * loading
 * customFilters
 * view
 * selFilter
 * 
 * applyFilters
 * 
*/

const styles = (theme) => ({});

const defaultFilters = {
	filterCourse: "",
	filterInstructor: "",
	filterTerm: "",
	filterCourseCreateBefore: null,
	filterCourseCreateAfter: null,
	filterStudentsLessThan: "",
	filterStudentsGreaterThan: "",
	filterLastPoll: null,
	filterAllCourses: false,
	filterActive: "both",
	filterAnonymous: "both",
	filterStarred: "both",
	filterCustom: "",
};

function AdminCourseFilters(props) {
	const [filterName, setFilterName] = React.useState(props.selFilter?.filterName ?? "");
	const [filterCourse, setFilterCourse] = React.useState(props.selFilter?.filterCourse ?? defaultFilters.filterCourse);
	const [filterInstructor, setFilterInstructor] = React.useState(props.selFilter?.filterInstructor ?? defaultFilters.filterInstructor);
	const [filterTerm, setFilterTerm] = React.useState(props.selFilter?.filterTerm ?? defaultFilters.filterTerm);
	const [filterCourseCreateBefore, setFilterCourseCreateBefore] = React.useState(props.selFilter?.filterCourseCreateBefore ?? defaultFilters.filterCourseCreateBefore);
	const [filterCourseCreateAfter, setFilterCourseCreateAfter] = React.useState(props.selFilter?.filterCourseCreateAfter ?? defaultFilters.filterCourseCreateAfter);
	const [filterStudentsLessThan, setFilterStudentsLessThan] = React.useState(props.selFilter?.filterStudentsLessThan ?? defaultFilters.filterStudentsLessThan);
	const [filterStudentsGreaterThan, setFilterStudentsGreaterThan] = React.useState(props.selFilter?.filterStudentsGreaterThan ?? defaultFilters.filterStudentsGreaterThan);
	const [filterLastPoll, setFilterLastPoll] = React.useState(props.selFilter?.filterLastPoll ?? defaultFilters.filterLastPoll);
	const [filterAllCourses, setFilterAllCourses] =  React.useState(props.selFilter?.filterAllCourses ?? defaultFilters.filterAllCourses);
	const [filterActive, setFilterActive] = React.useState(props.selFilter?.filterActive ?? defaultFilters.filterActive);
	const [filterAnonymous, setFilterAnonymous] = React.useState(props.selFilter?.filterAnonymous ?? defaultFilters.filterAnonymous);
	const [filterStarred, setFilterStarred] = React.useState(props.selFilter?.filterStarred ?? defaultFilters.filterStarred);
	const [filterCustom, setFilterCustom] = React.useState(defaultFilters.filterCustom);

	const applyFilters = () => {
		const data = {
			filterName: filterName,
			filterCourse: filterCourse,
			filterInstructor: filterInstructor,
			filterTerm: filterTerm,
			filterCourseCreateAfter: filterCourseCreateAfter,
			filterCourseCreateBefore: filterCourseCreateBefore,
			filterStudentsLessThan: filterStudentsLessThan,
			filterStudentsGreaterThan: filterStudentsGreaterThan,
			filterLastPoll: filterLastPoll,
			filterActive: filterActive,
			filterAnonymous: filterAnonymous,
			filterStarred: filterStarred,
			filterAllCourses: filterAllCourses,
		};
		props.applyFilters(data);
	};

	const setFilters = (filterVals) => {
		setFilterCourse(filterVals.filterCourse);
		setFilterTerm(filterVals.filterTerm);
		setFilterInstructor(filterVals.filterInstructor);
		setFilterCourseCreateAfter(filterVals.filterCourseCreateBefore);
		setFilterCourseCreateBefore(filterVals.filterCourseCreateAfter);
		setFilterStudentsLessThan(filterVals.filterStudentsLessThan);
		setFilterStudentsGreaterThan(filterVals.filterStudentsGreaterThan);
		setFilterLastPoll(filterVals.filterLastPoll);
		setFilterActive(filterVals.filterActive);
		setFilterAnonymous(filterVals.filterAnonymous);
		setFilterStarred(filterVals.filterStarred);
		setFilterAllCourses(filterVals.filterAllCourses);
		setFilterCustom(filterVals.filterCustom);
	};

	const resetFilters = (allCourses) => {
		let newFilters = {...defaultFilters};
		newFilters["filterAllCourses"] = allCourses;
		setFilters(newFilters);
		props.setError(false);
	};

  return (
		<>
			{props.view === "edit" && 
				<TextField 
					id="name" 
					label="Filter Name" 
					variant="outlined" 
					style={{marginBottom: 15}}
					value={filterName}
					onChange={(event) => {
							setFilterName(event.target.value);
					}}
				/>
			}
			{/* <Divider /> */}
			<FormControlLabel
				label="Show All Courses" 
				control={
					<Checkbox
						checked={filterAllCourses}
						onChange={(event) => {
							setFilterAllCourses(event.target.checked);
							resetFilters(event.target.checked);
						}}
					/>
				}
			/>
			<TextField 
				id="course" 
				label="Course" 
				disabled={filterAllCourses}
				variant="outlined" 
				value={filterCourse}
				onChange={(event) => {
					setFilterCourse(event.target.value);
					setFilterCustom(defaultFilters.customFilters);
				}}
			/>
			<TextField 
				id="instructor" 
				label="Instructor" 
				disabled={filterAllCourses}
				variant="outlined" 
				value={filterInstructor}
				onChange={(event) => {
					setFilterInstructor(event.target.value);
					setFilterCustom(defaultFilters.customFilters);
				}}
			/>
			<TextField 
				id="term" 
				label="Term" 
				disabled={filterAllCourses}
				variant="outlined" 
				value={filterTerm}
				onChange={(event) => {
					setFilterTerm(event.target.value);
					setFilterCustom(defaultFilters.customFilters);
				}}
			/>
			<TextField
				variant="outlined"
				label="Tot. Students Less Than"
				disabled={filterAllCourses}
				value={filterStudentsLessThan}
				onChange={(event) => {
					setFilterCustom(defaultFilters.customFilters);

					if (!isNaN(+event.target.value) || event.target.value === "") {
						setFilterStudentsLessThan(event.target.value);
					}
				}}
			/>
			<TextField
				variant="outlined"
				label="Tot. Students Greater Than"
				disabled={filterAllCourses}
				value={filterStudentsGreaterThan}
				onChange={(event) => {
					setFilterCustom(defaultFilters.customFilters);

					if (!isNaN(+event.target.value) || event.target.value === "") {
						setFilterStudentsGreaterThan(event.target.value);
					}
				}}
			/>
			<DatePicker
				disabled={filterAllCourses}
				label="Course Created Before"
				value={filterCourseCreateBefore}
				onChange={(newValue) => {
					setFilterCourseCreateBefore(newValue === null? newValue: newValue.valueOf());
					setFilterCustom(defaultFilters.customFilters);
				}}
				renderInput={(params) => <TextField {...params} />}
			/>
			<DatePicker
				disabled={filterAllCourses}
				label="Course Created After"
				value={filterCourseCreateAfter}
				onChange={(newValue) => {
					setFilterCourseCreateAfter(newValue === null ? newValue : newValue.valueOf());
					setFilterCustom(defaultFilters.customFilters);
				}}
				renderInput={(params) => <TextField {...params} />}
			/>
			<DatePicker
				disabled={filterAllCourses}
				label="Last Poll Before"
				value={filterLastPoll}
				onChange={(newValue) => {
					setFilterLastPoll(newValue === null ? newValue : newValue.valueOf());
					setFilterCustom(defaultFilters.customFilters);
				}}
				renderInput={(params) => <TextField {...params}  />}
			/>
			<FormControl>
				<InputLabel id="filterActiveLabel">Active Courses</InputLabel>
				<Select
					displayEmpty
					labelId="filterActiveLabel"
					disabled={filterAllCourses}
					id="filterActive"
					value={filterActive}
					label="Active Courses"
					onChange={(event) => {
						setFilterActive(event.target.value);
						setFilterCustom(defaultFilters.customFilters);
					}}
				>
					<MenuItem value={"both"}>Include Active and Inactive</MenuItem>
					<MenuItem value={"active"}>Only Include Active</MenuItem>
					<MenuItem value={"inactive"}>Only Include Inactive</MenuItem>
				</Select>
			</FormControl>
			<FormControl>
				<InputLabel id="filterAnonymousLabel">Anonymous Courses</InputLabel>
				<Select
					displayEmpty
					labelId="filterAnonymousLabel"
					disabled={filterAllCourses}
					id="filterAnonymous"
					value={filterAnonymous}
					label="Anonymous Courses"
					onChange={(event) => {
						setFilterAnonymous(event.target.value);
						setFilterCustom(defaultFilters.customFilters);
					}}
				>
					<MenuItem value={"both"}>Include Anonymous and Regular</MenuItem>
					<MenuItem value={"anonymous"}>Only Include Anonymous</MenuItem>
					<MenuItem value={"regular"}>Only Include Regular</MenuItem>
				</Select>
			</FormControl>
			<FormControl>
				<InputLabel id="filterStarredLabel">Starred Courses</InputLabel>
				<Select
					displayEmpty
					labelId="filterStarredLabel"
					disabled={filterAllCourses}
					id="filterStarred"
					value={filterStarred}
					label="Starred Courses"
					onChange={(event) => {
						setFilterStarred(event.target.value);
						setFilterCustom(defaultFilters.customFilters);
					}}
				>
					<MenuItem value={"both"}>Include Starred and Unstarred</MenuItem>
					<MenuItem value={"starred"}>Only Include Starred</MenuItem>
					<MenuItem value={"unstarred"}>Only Include Unstarred</MenuItem>
				</Select>
			</FormControl>
      {props.view === "apply" && 
				<FormControl>
					<FormLabel component="legend">Custom Filters:</FormLabel>
					<FormGroup>
						{Object.entries(props.customFilters).map(([filterID, filter]) => 
							<FormControlLabel
								key={filterID + "_fcl"}
								control={
									<Checkbox 
										disabled={filterAllCourses}
										checked={filterCustom === filterID}
										onChange={(event) => {
											setFilterCustom(event.target.checked ? filterID : "");

											if (event.target.checked) {
												let newFilters = {...filter};
												newFilters["filterCustom"] = filterID;
												setFilters(newFilters);
											} 
										}} 
									/>
								}
								label={filter.filterName}
							/>
						)}
					</FormGroup>
				</FormControl>	
			}
			{props.error && <Typography color="error">{props.error}</Typography>}
			
			{props.view === "apply" ? 
				<>
					<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
						<Button 
							variant="text" 
							color="primary"
							style={{ display: props.loading ? "none" : "block"}}
							onClick={() => {
								applyFilters();
							}}
						>
							Apply
						</Button>
						<Button 
							variant="text" 
							color="primary"
							style={{ display: props.loading ? "none" : "block"}}
							onClick={() => {
									resetFilters(false);
							}}
						>
							Clear
						</Button>
					</div> 
					<LinearProgress style={{display: props.loading ? "block" : "none" }} /> 
				</>
				: 
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
						<Button 
							variant="text" 
							color="primary"
							style={{ display: props.loading ? "none" : "block"}}
							onClick={() => {
								applyFilters();
							}}
						>
							Save
						</Button>
						{props.selFilter && <Button 
							variant="text" 
							color="primary"
							style={{ display: props.loading ? "none" : "block"}}
							onClick={() => {
								props.deleteFilter();
							}}
						>
							Delete
						</Button>}
						<Button 
							variant="text" 
							color="primary"
							style={{ display: props.loading ? "none" : "block"}}
							onClick={() => {
								props.setError(false);
								props.openFilterEdit(false);
							}}
						>
							Cancel
						</Button>
					</div> 
			}
		</>
  )
}


const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(AdminCourseFilters)
    )
  )
);